var _Rect, _Rect2, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
var SvgIndicatorAdd = function SvgIndicatorAdd(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 18"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    fill: "#330E07",
    rx: 8.5
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    stroke: "#FFD766",
    rx: 8.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFD766",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M5 9h8M9 5v8"
  })));
};
export default SvgIndicatorAdd;